module.exports = __webpack_public_path__ + "img/sad.c2c8b886.svg";